import React, { useState, useEffect } from "react";
import WhyLMItem from "../../components/whyLMSection/WhyLMItem";
import { BenefitProducts } from "../../../domain/entities/BenefitProducts";
import { fetchBenefitProducts } from "../../../domain/usecases/fetchBenefitProducts";   
import "react-multi-carousel/lib/styles.css";
import SpinnerLoading from "../../components/spinnerLoading/SpinnerLoading";

const WhyLMSection: React.FC = () => {

    const [benefitProducts, setBenefitProducts] = useState<BenefitProducts[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    // Fetch benefits
    useEffect(() => {
        const fetchBenefits = async () => {
            try {
                const benefitProducts = await fetchBenefitProducts();
                
                // Extract and set both desktop and mobile banners
                const benefitItems = benefitProducts.map((benefit) => benefit);
                
                setBenefitProducts(benefitItems);
            } catch (err) {
                console.error("Failed to fetch banners:", err);
                setError("Failed to load banners. Please try again later.");
            } finally {
                setLoading(false);
            }
        };

        fetchBenefits();
    }, []);

    // Handle loading state
    if (loading) {
        return <SpinnerLoading />;
    }

    // Handle error state
    if (error) {
        return <div className="text-center text-red-500">{error}</div>;
    }

    return (
        <div className="p-8 bg-white shadow-md rounded-3xl my-4 max-w-full mx-8 md:mx-16">
            <h2 className="text-center text-2xl font-bold mb-6 font-poppins">Keuntungan memilih Life Media</h2>
            <div className="grid grid-cols-1 md:grid-cols-4 justify-between items-stretch gap-6 md:gap-6">
                {benefitProducts.map( (items) => (
                    <WhyLMItem imageUrl={items.icon} title={items.title} description={items.description} />
                ))}
            </div>
        </div>
    );
};

export default WhyLMSection;